interface IGetSelectValue {
  value?: Nullable<string>;
  label?: Nullable<string>;
  tagLabel?: Nullable<string>;
  description?: Nullable<string>;
}

function getSelectValue({ value, label = value, tagLabel, description }: IGetSelectValue) {
  return value
    ? {
        label: description
          ? {
              title: label,
              description,
            }
          : label,
        value,
        ...(tagLabel && {
          tag: {
            label: tagLabel,
          },
        }),
      }
    : null;
}

export default getSelectValue;
